<template>
  <a-modal
      :title="title"
      :width="720"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      @ok="handleSubmit"
      @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="工具名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
              placeholder="请输入工具名称"
              v-decorator="['tool_name', {rules: [{required: true, message: '请输入工具名称'}]}]"
          />
        </a-form-item>
        <a-form-item label="工具单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
              placeholder="请输入工具单价"
              v-decorator="['price', {rules: [{required: true, message: '请输入工具单价'}]}]"
          />
        </a-form-item>

        <a-form-item label="单位名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
              placeholder="请输入单位名称"
              v-decorator="['tool_unit', {rules: [{required: true, message: '请输入单位名称'}]}]"
          />
        </a-form-item>
        <a-form-item label="剩余库存" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
              style="width: 100%"
              :min="0"
              :max="999999999"
              placeholder="请输入剩余库存"
              v-decorator="['inventory', {rules: [{required: true, message: '请输入剩余库存'}]}]"
          />
        </a-form-item>

        <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
              allowClear
              v-decorator="['tc_id', {initialValue: !isEmpty(record.tc_id)?record.tc_id:(tc_id||undefined),rules: [{required: true, message: '请选择所属分类'}]}]"
              placeholder="请选择所属分类"
          >
            <a-select-option v-for="item in categoryList" :value="item.tc_id">
              {{ item.category_name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="采购地点" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
              placeholder="请输入采购地点"
              v-decorator="['purchase_address', {rules: [{required: true, message: '请输入采购地点'}]}]"
          />
        </a-form-item>

        <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group
              v-decorator="['tool_type', { initialValue: 0,rules: [{ required: true }] }]"
          >
            <a-radio :value="0">随车用品</a-radio>
            <a-radio :value="1">燃油</a-radio>
            <a-radio :value="2">尿素</a-radio>
            <a-radio :value="3">轮胎</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="启用状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group
              v-decorator="['status', { initialValue: 0,rules: [{ required: true }] }]"
          >
            <a-radio :value="0">启用</a-radio>
            <a-radio :value="1">停用</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

import * as Api from '@/api/tool'
import * as toolCategoryApi from '@/api/tool/toolCategory'
import {UploadFile} from '@/components'
import _ from "lodash";
import {isEmpty} from "@/utils/util";

export default {
  props: {
    tc_id: {
      type: String || Number,
      default: ''
    }
  },
  components: {
    UploadFile
  },
  data() {
    return {
      // 对话框标题
      title: '',
      // 标签布局属性
      labelCol: {
        span: 7
      },
      // 输入框布局属性
      wrapperCol: {
        span: 13
      },
      // modal(对话框)是否可见
      visible: false,
      // modal(对话框)确定按钮 loading
      confirmLoading: false,
      // 当前表单元素
      form: this.$form.createForm(this),
      // 当前记录
      record: {},
      // 当前模式 add新增 edit编辑
      mode: "",

      categoryList: []
    }
  },
  methods: {
    isEmpty,

    /**
     * 显示对话框
     */
    add() {
      this.getToolCategory()
      this.mode = "add"
      this.title = '新增工具'
      this.visible = true
    },
    edit(record) {
      this.getToolCategory()
      this.mode = "edit"
      this.title = '编辑工具'
      this.visible = true

      this.record = record
      this.setFieldsValue()
    },

    async getToolCategory() {
      const {data: {list}} = await toolCategoryApi.allList()
      this.categoryList = list
    },

    /**
     * 设置默认值
     */
    setFieldsValue() {
      const {form: {setFieldsValue}} = this
      this.$nextTick(() => {
        const data = _.pick(this.record, ['tool_name', 'price', 'tool_unit', 'inventory', 'purchase_address', 'tool_type', 'status'])
        setFieldsValue(data)
      })
    },

    /**
     * 确认按钮
     */
    handleSubmit(e) {
      e.preventDefault()
      const {form: {validateFields}} = this
      // 表单验证
      validateFields((errors, values) => {
        // 提交到后端api
        !errors && this.onFormSubmit(values)
      })
    },

    /**
     * 关闭对话框事件
     */
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },

    /**
     * 提交到后端api
     */
    onFormSubmit(values) {
      this.confirmLoading = true
      var sendApi = null
      if (this.mode == "add") {
        // values.tc_id = this.tc_id
        sendApi = Api.add({form: values})
      } else {
        sendApi = Api.edit({toolId: this.record['tool_id'], form: values})
      }
      sendApi.then((result) => {
        // 显示成功
        this.$message.success(result.message, 1.5)
        // 关闭对话框
        this.handleCancel()
        // 通知父端组件提交完成了
        this.$emit('handleSubmit', values)
      })
          .finally((result) => {
            this.confirmLoading = false
          })
    }

  }
}
</script>
